export enum ANIMATED_STYLE {
    NONE = "none",
    FADE_IN = "fadeIn",
    FADE_IN_UP = "fadeInUp",
    FADE_IN_DOWN = "fadeInDown",
    FADE_IN_LEFT = "fadeInLeft",
    FADE_IN_RIGHT = "fadeInRight",
    FADE_IN_UP_BIG = "fadeInUpBig",
    FADE_IN_DOWN_BIG = "fadeInDownBig",
    FADE_IN_LEFT_BIG = "fadeInLeftBig",
    FADE_IN_RIGHT_BIG = "fadeInRightBig",
    //FADE_OUT = "fadeOut",
    //FADE_OUT_UP = "fadeOutUp",
    //FADE_OUT_DOWN = "fadeOutDown",
    //FADE_OUT_LEFT = "fadeOutLeft",
    //FADE_OUT_RIGHT = "fadeOutRight",
    //FADE_OUT_BIG = "fadeOutUpBig",
    //FADE_OUT_DOWN_BIG = "fadeOutDownBig",
    //FADE_OUT_LEFT_BIG = "fadeOutLeftBig",
    //FADE_OUT_RIGHT_BIG = "fadeOutRightBig",
    BOUNCE_IN = "bounceIn",
    //SLIDE_IN_DOWN = "slideInDown",
    //SLIDE_IN_LEFT = "slideInLeft",
    //SLIDE_IN_RIGHT = "slideInRight",
    //SLIDE_OUT_LEFT = "slideOutLeft",
    //SLIDE_OUT_RIGHT = "slideOutRight",
    //SLIDE_OUT_UP = "slideOutUp", 
    BOUNCE_IN_UP = "bounceInUp",
    BOUNCE_IN_DOWN = "bounceInDown",
    BOUNCE_IN_LEFT = "bounceInLeft",
    BOUNCE_IN_RIGHT = "bounceInRight",
    //BOUNCE_OUT = "bounceOut",
    //BOUNCE_OUT_UP = "bounceOutUp",
    //BOUNCE_OUT_DOWN = "bounceOutDown",
    //BOUNCE_OUT_LEFT = "bounceOutLeft",
    //BOUNCE_OUT_RIGHT = "bounceOutRight",
    ROTATE_IN = "rotateIn",
    ROTATE_IN_UP_LEFT = "rotateInUpLeft",
    ROTATE_IN_DOWN_LEFT = "rotateInDownLeft",
    ROTATE_IN_UP_RIGHT = "rotateInUpRight",
    ROTATE_IN_DOWN_RIGHT = "rotateInDownRight",
    //ROTATE_OUT = "rotateOut",
    //ROTATE_OUT_UP_LEFT = "rotateOutUpLeft",
    //ROTATE_OUT_DOWN_LEFT = "rotateOutDownLeft",
    //ROTATE_OUT_UP_RIGHT = "rotateOutUpRight",
    //ROTATE_OUT_DOWN_RIGHT = "rotateOutDownRight",
    //ROLL_IN = "rollIn",
    //ROLL_OUT = "rollOut",
    LIGHT_SPEED_IN = "lightSpeedIn",
    //LIGHT_SPEED_OUT = "lightSpeedOut",
    //HINGE = "hinge",
    FLASH = "flash",
    SHAKE = "shake",
    BONCE = "bounce",
    TADA = "tada",
    SWING = "swing",
    //WOBBLE = "wobble",
    PULSE = "pulse",
    FLIP = "flip",
    FLIP_IN_X = "flipInX",
    //FLIP_OUT_X = "flipOutX",
    FLIP_IN_Y = "flipInY", 
} 


export enum ANIMATE_DELAY {
    NONE="",
    WATERFALL="waterfall",

}